'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var p = require('prop-types');
var reactRouterDom = require('react-router-dom');

/**
 * @author [a.seravalli](http://gitea.armundia.com/a.seravalli)
 * 
 * Componente che gestisce un container flex, e, in base alle properties passate,
 * dispone i children in linea o in colonna, estendendosi (di default) su tutto lo spazio disponibile
 * 
 * @example
 * 
 * ```jsx
 * const alignItems = 'flex-end',
 *       height = 'calc(100vh - 70px)',
 *       width = '150px',
 *       vertical = true,
 *       id = 'id-menu',
 *       className = 'selectors';
 * <Menu alignItems={alignItems} height={position} width={width} vertical={vertical} id={id} className={className} >
 *     ...
 *     <MenuLink/>
 *     <MenuDrop>
 *         <MenuLink/>
 *         ...
 *     </MenuDrop>
 *     ...
 * </Menu>
 * ```
 */

var Menu = function Menu(props) {
  console.log('[Menu.jsx]: render');
  var alignItems = props.alignItems,
      height = props.height,
      width = props.width,
      vertical = props.vertical,
      reverse = props.reverse,
      id = props.id,
      className = props.className,
      children = props.children;
  var barStyle = {
    display: 'flex',
    alignItems: alignItems || 'center',
    height: height || '100vh',
    width: width || '100%'
  };

  if (vertical) {
    barStyle.flexDirection = 'column';
    if (!width) delete barStyle.width;
  } else {
    barStyle.flexDirection = 'row';
    if (!height) delete barStyle.height;
  }

  if (reverse) barStyle.flexDirection += '-reverse';
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: barStyle,
    className: className ? 'arm-menu ' + className : 'arm-menu'
  }, children);
};

Menu.propTypes = {
  /** proprieta' css-flexbox align-items (es: center, flex-end, flex-start ecc.) */
  alignItems: p.string,

  /** altezza del contenitore (se vertical = true default: '100vh') */
  height: p.string,

  /** altezza del contenitore (se vertical = true default: '100vh') */
  width: p.string,

  /** se true, dispone la barra in colonna */
  vertical: p.bool,

  /** se true, inverte la disposizione degli elementi */
  reverse: p.bool,

  /** id del contenitore */
  id: p.string,

  /** selettore del contenitore */
  className: p.string,

  /** React children */
  children: p.node
};

/**
 * Componente che inserisce in un div il componente NavLink (react-router-dom)
 * inserendovi le prop necessarie per il suo corretto funzionamento
 * 
 * @see NavLink parameters: https://reacttraining.com/react-router/web/api/NavLink
 * 
 * @example
 * 
 * ```jsx
 * const id = 'id-menulink',
 *       className = 'selectors';
 *       to = '/path/to/go',
 *       activeStyle = {color: 'red', backgroundColor: 'grey'}, //only if you want change default behaviour
 *       strict = 'true',
 *       onClick = () => { alert("The path is changed") }
 * <MenuLink id={id} className={className} to={to} activeStyle={activeStyle} strict={strict} onClick={onClick}>
 *     <LabelComponent/>
 * </MenuLink>
 * ```
 */

var MenuLink = function MenuLink(props) {
  var className = props.className,
      linkClassName = props.linkClassName,
      activeClassName = props.activeClassName;
  var wrapperClass = ' arm-router-menu-link ';

  if (className) {
    wrapperClass += className;
  }

  var linkClass = ' arm-router-menu-nav-link ';

  if (linkClassName) {
    linkClass += linkClassName;
  }

  var activeClass = ' arm-router-menu-nav-link-selected ';

  if (activeClassName) {
    activeClass += activeClassName;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: props.id,
    className: wrapperClass
  }, /*#__PURE__*/React.createElement(reactRouterDom.NavLink, {
    to: props.to,
    className: linkClass,
    activeClassName: activeClass,
    activeStyle: props.activeStyle,
    exact: props.exact,
    strict: props.strict,
    isActive: props.isActive,
    onClick: props.onClick
  }, props.label || props.children));
};

MenuLink.propTypes = {
  /** id del div */
  id: p.string,

  /** selettore del div */
  className: p.string,

  /** selettore del navLink */
  linkClassName: p.string,

  /** selettore del selected navLink */
  activeClassName: p.string,

  /** etichetta dell'anchor */
  label: p.string,

  /** React children */
  children: p.node,

  /** path "href" di NavLink */
  to: p.string,

  /** oggetto contenente lo style attribuito quando e' selezionato */
  activeStyle: p.object,

  /** il selezionamento viene applicato se la location e' identica al "to" */
  exact: p.bool,

  /** @see https://reacttraining.com/react-router/core/api/Route/strict-bool */
  strict: p.bool,

  /** funzione che aggiunge una logica extra per il selezionamento */
  isActive: p.func,

  /** per attribuzione di comportamenti diversi da quello di default */
  onClick: p.func
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

var menudropId = 0;

var setId = function setId() {
  return "menu-drop-" + menudropId++;
};

var MenuDrop = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MenuDrop, _React$PureComponent);

  var _super = _createSuper(MenuDrop);

  function MenuDrop(props) {
    var _this;

    _classCallCheck(this, MenuDrop);

    _this = _super.call(this, props);

    _this.componentLog = function (type, elem) {
      return console.log("[MenuDrop.jsx]: " + type, elem ? elem : null);
    };

    _this.state = {
      paths: new Map(),
      show: false,
      selected: null,
      on: false,
      //variabile usata per il selezionamento. Property messa perche' se tra il padre e l'ultimo MenuDrop ci sono altri MenuDrop, questi devono apparire selezionati (per capire in quale tendina si trova il figlio selezionato)
      id: props.id || setId()
    };
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onChangeSelected = _this.onChangeSelected.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MenuDrop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.componentLog("componentDidMount");
      var _this$props = this.props,
          hover = _this$props.hover,
          children = _this$props.children; //Creo una mappa path => path dei vari MenuLink

      var paths = this.state.paths;
      React.Children.forEach(children, function (child) {
        return child.props && child.props.to ? paths.set(child.props.to, child.props.to) : null;
      });
      this.setState({
        paths: paths
      });
      if (!hover) window.addEventListener("click", this.onBlur);
      this.updateComponent();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentLog("componentWillUnmount");
      if (!this.props.hover) window.removeEventListener("click", this.onBlur);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.componentLog("componentDidUpdate");
      this.updateComponent(prevProps);
    }
  }, {
    key: "updateComponent",
    value: function updateComponent(prevProps) {
      var pathname = this.props.location.pathname;
      var paths = this.state.paths;
      var selected = this.props.selected !== undefined ? this.props.selected : //MenuDrop figlio di un MenuDrop
      this.state.selected; //MenuDrop padre

      if (prevProps) {
        //Chiude il drop quando si ha un cambio di path (caso di apertura con click)
        if (prevProps.location.pathname !== pathname && !this.props.hover && this.state.show) this.setState({
          show: false
        }); //Tutte le volte che cambia di path, il componente viene resettato

        if (prevProps.location.pathname !== pathname && selected !== null) return this.onChangeSelected(null);
      } //Per evitare un loop infinito nel DidUpdate, confronto il selected (che contiene il path settato) con il pathname


      if (selected !== pathname && paths.has(pathname)) this.onChangeSelected(pathname);
    }
    /**
     * Funzione per aggiornare lo stato del MenuDrop o dei MenuDrop, nel caso in cui il MenuDrop sia figlio di un MenuDrop
     * 
     * @param {*} selected path o null
     */

  }, {
    key: "onChangeSelected",
    value: function onChangeSelected(selected) {
      var updateState = {};
      updateState.on = !!selected; //MenuDrop deve apparire selezionato (in caso di path) o deselezionato (in caso di null)

      if (!!this.props.onChangeSelected) this.props.onChangeSelected(selected); //caso MenuDrop figlio di un MenuDrop
      else updateState.selected = selected; //caso MenuDrop padre

      this.setState(updateState);
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      return document.getElementById(this.state.id).contains(e.target) || this.setState({
        show: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      this.componentLog("render");
      var _this$props2 = this.props,
          hover = _this$props2.hover,
          label = _this$props2.label,
          className = _this$props2.className,
          children = _this$props2.children;
      var _this$state = this.state,
          on = _this$state.on,
          id = _this$state.id,
          show = _this$state.show;
      var selected = this.props.selected !== undefined ? this.props.selected : //MenuDrop figlio di un MenuDrop
      this.state.selected; //MenuDrop padre

      var onClick = function onClick() {
        return _this2.setState({
          show: !show
        });
      };

      var componentClassName = "arm-menu-drop";

      if (hover) {
        componentClassName += " hoverable";
        onClick = null;
      } else if (show) {
        componentClassName += " active";
      }

      var position = this.props.position || "down";
      var icon = (this.props.icon || "fas fa-chevron-left ") + position;
      var iconLeft = null;
      var iconRight = /*#__PURE__*/React.createElement("i", {
        className: icon
      });

      if (position === "left") {
        iconLeft = /*#__PURE__*/React.createElement("i", {
          className: icon
        });
        iconRight = null;
      }

      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: className ? componentClassName + " " + className : componentClassName
      }, /*#__PURE__*/React.createElement("a", {
        className: on ? "arm-menu-dropbtn arm-router-menu-nav-link-selected" : "arm-menu-dropbtn",
        onClick: onClick
      }, iconLeft, " ", label, " ", iconRight), /*#__PURE__*/React.createElement("div", {
        className: "arm-menu-drop-content " + position.toLowerCase()
      }, React.Children.map(children, function (child) {
        if (child.type.toString() === MenuDropRouter.toString()) {
          //se sono dello stesso tipo (quindi il figlio è un MenuDrop)
          var childProperties = _extends({}, child.props); //Caso MenuDrop padre (this.props.selected === undefined) passo this.state.selected
          //Caso MenuDrop figlio di un MenuDrop (this.props.selected !== undefined) passo this.props.selected, che sarebbe il this.state.selected del padre


          childProperties.selected = selected; //

          childProperties.onChangeSelected = _this2.onChangeSelected;
          child = /*#__PURE__*/React.createElement(child.type, childProperties);
        }

        return child;
      })));
    }
  }]);

  return MenuDrop;
}(React.PureComponent);
/**
 * @author [a.seravalli](http://gitea.armundia.com/a.seravalli)
 * 
 * Componente che crea un menu a tendina a scomparsa gestendo dei MenuLink.
 * Se il MenuDrop contiene a sua volta altri MenuDrop, ed uno di questi ha un MenuLink selezionato,
 * il componente e tutti i MenuDrop fra il padre e l'ultimo appariranno selezionati (ricorsivamente)  
 * 
 * @augments {Component<{hover: boolean, position: string, label: string, id: string, className: string}, State>}
 * 
 * @example
 * 
 * ```jsx
 * const hover = true,
 *       position = 'up',
 *       label = 'prova',
 *       id = 'id-menudrop',
 *       className = 'selectors';
 * <MenuDrop hover={hover} position={position} label={label} id={id} className={className} >
 *     ...
 *     <MenuLink/>
 *     <MenuDrop>
 *         <MenuLink/>
 *         ...
 *     </MenuDrop>
 *     ...
 * </MenuDrop>
 * ```
 */


var MenuDropRouter = function MenuDropRouter(props) {
  return /*#__PURE__*/React.createElement(MenuDrop, _extends({
    location: reactRouterDom.useLocation()
  }, props));
}; //aggancia il location di react-router-dom e necessario per riga 88


MenuDropRouter.propTypes = {
  /** se true, al passaggio del mouse la tendina si apre, false, la tendina si apre con il click */
  hover: p.bool,

  /** down, up, left, right (posizioni della tendina) */
  position: function position(props, propName, componentName) {
    if (props[propName] === undefined) return null;
    var oneOf = ["down", "up", "left", "right"];

    if (typeof props[propName] !== "string" || !oneOf.find(function (e) {
      return e === props[propName].toLowerCase();
    })) {
      //se non e' una stringa o se non fa parte dell'array lancio errore
      return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. It needs to be one of this strings: [' + oneOf.toString() + '].');
    }
  },

  /** etichetta del pulsante */
  label: p.string,

  /** id del contenitore */
  id: p.string,

  /** selettore del contenitore */
  className: p.string,

  /** React children */
  children: p.node
};

var name = "arm-router";
var version = "1.0.5";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "./dist/main/index.js";
var files = [
	"dist"
];
var devDependencies = {
	"arm-core-layouts": "0.1.13",
	"arm-gui": "3.0.10",
	"arm-gulp-builders": "1.1.3",
	"arm-themes": "1.1.1",
	"arm-visual-component": "^2.1.0",
	"babel-eslint": "^10.0.3",
	"babel-plugin-markdown": "^0.3.0",
	"eslint-plugin-import": "2.22.0",
	"eslint-plugin-react": "7.20.3",
	"immutability-helper": "^3.1.1",
	react: "16.13.1",
	"react-dom": "16.13.1",
	"react-markdown": "^4.2.2",
	"react-redux": "^7.2.0",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var dependencies = {
	"prop-types": "15.7.2",
	"react-router-dom": "5.2.0"
};
var scripts = {
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish"
};
var publishConfig = {
	registry: "http://nexus.armundia.com:8081/repository/npm-releases/"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

var armRouter = {
  version: pckg.version,
  Menu: Menu,
  MenuLink: MenuLink,
  MenuDrop: MenuDropRouter
};

exports.Menu = Menu;
exports.MenuDrop = MenuDropRouter;
exports.MenuLink = MenuLink;
exports.default = armRouter;
//# sourceMappingURL=index.js.map
